import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { EstatusJSON } from '../../models/EstatusJSON';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';

@Injectable({
  providedIn: 'root'
})
export class DashboardAPIService implements IApiBase{
  configUrl: string;
  
  constructor(private http: HttpClient, private router: Router) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  getResume(): Observable<EstatusJSON> {
    if(!environment.production) console.log('/api/Dashboard/GetResume');
    return this.http.get<EstatusJSON>(
      `${this.configUrl}/api/Dashboard/GetResume`,
    );
  }

  getTableauReports(): Observable<EstatusJSON>{
    if(!environment.production) console.log("/api/Dashboard/GetTableauReports/");
    return this.http.get<EstatusJSON>(
      `${this.configUrl}/api/Dashboard/GetTableauReports`,
    );
    
  }  
}

